/**
 * Staff/Admin User Registration with Invitation Token
 * Allows invited users to create their accounts
 */

import React from 'react';
import { RegisterWithInvite } from '@/components/auth/RegisterWithInvite';

export default function RegisterPage() {
  return <RegisterWithInvite />;
}
